module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"ご利用できる全国の倉庫"},"en":{"title":"Available warehouses in Japan"}}')
  delete Component.options._Ctor
}
